import { render, staticRenderFns } from "./EventModalCatalogParticipantsListForm.vue?vue&type=template&id=10fe42f4&scoped=true"
import script from "./EventModalCatalogParticipantsListForm.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogParticipantsListForm.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogParticipantsListForm.vue?vue&type=style&index=0&id=10fe42f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe42f4",
  null
  
)

export default component.exports